import { withRouter } from "react-router-dom/cjs/react-router-dom.min"
import SideBar from "../component/SideBar"
import Actions from "../redux/actions"
import AppLoader from "../utils/AppLoader"
import Header from "../component/Header"
import React from 'react';
import { connect } from "react-redux"
import ViewRoomService from "../component/ViewRoomService"

class VendorViewRoomService extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            vendorRoomServiceDetailData: [],
            isLoading: false
        }
    }
    componentDidMount() {
        this.getRoomServicedDetail()
    }
    getRoomServicedDetail = () => {
        const route = window.location.href.split('/')
        let params = {
            id: this.props.match.params.id
        }
        const callback = (response) => {
            if (response) {
                this.setState({ viewData: response?.response, isLoading: false })
            }
        }
        this.setState({ isLoading: true })
        this.props.getVendorRoomServiceDetail(params, callback)
    }
    render() {
        const { getVendorRoomService = {} } = this.props
        const { isLoading, vendorRoomServiceDetailData } = getVendorRoomService
        return (
            <div className="dashboard-screen-part">
                <div className="d-flex p-0">
                    <SideBar />
                    <div className="card-right p-0">
                        <Header />
                        <ViewRoomService data={vendorRoomServiceDetailData} />
                    </div>
                </div>
                {isLoading && <AppLoader />}
            </div>
        )
    }
}

export const mapStateToProps = (state) => {
    return {
        getVendorRoomService: Actions.getVendorRoomService(state)
    }
};

export default withRouter(connect(mapStateToProps, {
    getVendorRoomServiceDetail: Actions.getVendorRoomServiceDetail,
})(VendorViewRoomService));